import { useInfiniteQuery as m } from "react-query";
import { useAuth as a } from "../../../auth/hooks/useAuth.js";
import { useEnvironment as h } from "../../../common/hooks/environment/useEnvironment.js";
import { getAdapter as n } from "../../adapter.js";
import { OrderRecordAdapter as y } from "../../models/customer/orders/orderRecord/order.record.adapter.js";
import { ScopeAdapter as A } from "../../models/scope/scope.adapter.js";
function q(r = 20, s) {
  const {
    backendBaseUrl: c
  } = h(), {
    token: o,
    scope: i
  } = a(), d = s ?? i;
  return m({
    queryKey: ["orders", o],
    queryFn: async ({
      pageParam: e
    }) => {
      const t = n(A).toQueryString(d);
      t.set("record_number", r.toString()), e != null && e.endDate && t.set("end_date", e.endDate.toString());
      const u = await fetch(
        `${c}/user/order/?${t}`,
        {
          headers: {
            Authorization: `Token ${o}`
          }
        }
      ), {
        records: f = []
      } = await u.json(), p = n(y);
      return f.map(p.adapt);
    },
    getNextPageParam: (e) => {
      const t = e[e.length - 1];
      if (!(t === void 0 || e.length < r))
        return {
          endDate: t.timestamp.getTime() / 1e3
        };
    },
    keepPreviousData: !0,
    refetchOnWindowFocus: !1
  });
}
export {
  q as useOrderHistory
};
//# sourceMappingURL=useOrderHistory.js.map
